import React, { useState, useEffect, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { io } from 'socket.io-client';
import axios from 'axios';
import { PlusCircle, Edit3, ChevronLeft, ChevronRight,ChevronsLeft,ChevronsRight, Users, Settings as SettingsIcon, Search, ShieldCheck, HardHat, Eye, Trash2} from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';

import Sidebar from '../components/sidebar.js';
import TicketModal from '../components/ticketform.js';
import TeamView from '../components/teamview.js';
import ScriptsView from '../components/scriptview.js'; // Added Import
import ChatView from '../components/chatview.js';


// At the top of your App or Dashboard component
const savedUser = JSON.parse(localStorage.getItem('user'));
// Use this savedUser to trigger your socket.emit('join', savedUser.id)
const socket = io('http://localhost:5000');
const Dashboard = ({ user, setUser, showToast }) => {
  const [tickets, setTickets] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [isFormOpen, setIsFormOpen] = useState(false);
  const [selectedTicket, setSelectedTicket] = useState(null);
  const [formData, setFormData] = useState({ subject: '', ticket_owner: '', priority: 'Low', status: 'Open' });
  // Dashboard.js
  const [activeTab, setActiveTab] = useState(localStorage.getItem('activeTab') || 'tickets');
  const [searchTerm, setSearchTerm] = useState('');
  const navigate = useNavigate();
  const [unreadCount, setUnreadCount] = useState(0);
  
  useEffect(() => {
  fetchTickets(currentPage);
}, [currentPage]); // This ensures it refetches whenever page number changes
  

  // Dashboard.js
  useEffect(() => {
    if (user && user.id) {
      // If socket disconnected, reconnect
      if (!socket.connected) {
        socket.connect();
      }

      // Tell server we are online
      socket.emit('join', user.id);

      // Listen for reconnection (e.g. if server restarts)
      socket.on('connect', () => {
        socket.emit('join', user.id);
      });

      return () => {
        socket.off('connect');
      };
    }
  }, [user?.id]); // Watch for the user IDexistsly

  useEffect(() => {
    socket.on('receiveMessage', (message) => {
        // Increment badge if we aren't currently looking at the chat
        if (activeTab !== 'chat') {
            setUnreadCount(prev => prev + 1);
        }
    });
    return () => socket.off('receiveMessage');
}, [activeTab]);

// Reset badge when user clicks on Chat
useEffect(() => {
    if (activeTab === 'chat') {
        setUnreadCount(0);
    }
}, [activeTab]);

    // Dashboard.js
  useEffect(() => {
    localStorage.setItem('activeTab', activeTab);
  }, [activeTab]);
  // REAL-TIME SOCKET LISTENER
  useEffect(() => {
    // Initial fetch when page loads or changes
    fetchTickets(currentPage);

    // Socket Listeners
    socket.on('ticketCreated', (data) => {
        fetchTickets(currentPage);
        if (user.role === 'Admin') showToast("New ticket added!", "info");
    });

    socket.on('ticketUpdated', (data) => {
        fetchTickets(currentPage);
        showToast("A ticket was updated", "info");
    });

    socket.on('ticketDeleted', (data) => {
        fetchTickets(currentPage);
        showToast("A ticket was removed", "warning");
    });

    // Cleanup on unmount
    return () => {
        socket.off('ticketCreated');
        socket.off('ticketUpdated');
        socket.off('ticketDeleted');
    };
}, [currentPage, user.role]); // Added user.role and currentPage as dependencies
  const fetchTickets = async (page) => {
    try {
      const res = await axios.get(`http://localhost:5000/api/tickets?page=${page}`);
      const sortedData = res.data.data.sort((a, b) => a.id - b.id);
      setTickets(sortedData || []);
      setTotalPages(res.data.totalPages || 1);
    } catch (err) { 
      console.error("Fetch Error:", err); 
    }
  };

  const filteredTickets = useMemo(() => {
  return tickets.filter(t => {
    // We use (t.subject || "") to treat null/undefined as an empty string
    const subject = (t.subject || "").toLowerCase();
    const owner = (t.ticket_owner || "").toLowerCase();
    const id = (t.id || "").toString();
    const search = searchTerm.toLowerCase();

    return subject.includes(search) || 
           owner.includes(search) || 
           id.includes(search);
  });
  }, [tickets, searchTerm]);

  // Inside Dashboard.js
  const handleLogout = () => {
      // 1. Tell the socket to disconnect
      socket.disconnect(); 

      // 2. Clear local storage and state
      localStorage.removeItem('user'); 
      localStorage.removeItem('activeTab');
      setUser(null);
      
      // 3. (Optional) If you want to log back in without refreshing, 
      // you'll need to reconnect the socket on the login page.
  };

// Add 'note' as a parameter here
// dashboard.js
const handleSubmit = async (e, actionNote) => {
  e.preventDefault();

  const data = new FormData();
  
  // 1. Append existing form fields
  Object.keys(formData).forEach(key => {
    if (key === 'attachment') {
      if (formData.attachment instanceof File) data.append('attachment', formData.attachment);
    } else {
      data.append(key, formData[key] || "");
    }
  });

  // 2. IMPORTANT: Append the Note AND the Current Logged-in User's Name
  if (actionNote && actionNote.trim() !== "") {
    data.append('actionNote', actionNote);
    data.append('staffPerformingAction', user.name); // 'user' comes from Dashboard props
  }

  try {
    if (selectedTicket) {
      await axios.put(`http://localhost:5000/api/tickets/${selectedTicket.id}`, data);
      showToast(`Updated by ${user.name}`, "success");
    } else {
      await axios.post('http://localhost:5000/api/tickets', data);
      showToast("New Ticket Created", "success");
    }

    setIsFormOpen(false); 
    fetchTickets(currentPage);
  } catch (err) { 
    console.error("Submission Error:", err);
    showToast("Error processing request", "error"); 
  }
};

  const handleDelete = async (id) => {
  if (window.confirm("Are you sure you want to delete this ticket?")) {
    try {
      const res = await axios.delete(`http://localhost:5000/api/tickets/${id}`);
      if (res.data.success) {
        showToast("Ticket deleted permanently", "success");
        fetchTickets(currentPage); // Refresh the list
      }
    } catch (err) {
      console.error("Delete Error:", err);
      showToast("Failed to delete ticket", "error");
    }
  }

};

  return (
    <div className="app-container">
      <Sidebar 
        user={user} 
        handleLogout={handleLogout} 
        activeTab={activeTab} 
        setActiveTab={setActiveTab} 
        unreadCount={unreadCount}
      />

      <main className="main-content">
        <AnimatePresence mode="wait">
          
          {/* 1. TICKETS TAB */}
          {activeTab === 'tickets' && (
            <motion.div
              key="tickets-tab"
              initial={{ opacity: 0, x: 20 }}
              animate={{ opacity: 1, x: 0 }}
              exit={{ opacity: 0, x: -20 }}
              /* Added style to prevent top-jumping */
              style={{ width: '100%', display: 'flex', flexDirection: 'column' }}
            >
              <header className="top-header">
                <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                  {user.role === 'Admin' ? <ShieldCheck color="#6366f1" /> : <HardHat color="#f59e0b" />}
                  <div>
                    <h2 style={{ margin: 0 }}>
                      {user.role === 'Admin' ? 'ADMIN PANEL' : 'ENGINEER WORKSPACE'}
                    </h2>
                    <p style={{ color: '#64748b', fontSize: '14px' }}>
                      Logged in as {user.name} ({user.role})
                    </p>
                  </div>
                </div>

                <div className="header-actions" style={{ display: 'flex', gap: '12px', alignItems: 'center' }}>
                  <motion.div className="search-wrapper" initial={{ opacity: 0, y: -10 }} animate={{ opacity: 1, y: 0 }}>
                    <Search size={20} className="search-icon" />
                    <input 
                      type="text" 
                      placeholder="Search tickets..." 
                      className="search-input"
                      value={searchTerm}
                      onChange={(e) => setSearchTerm(e.target.value)}
                    />
                  </motion.div>

                  <motion.button 
                    className="new-ticket-btn"
                    whileHover={{ scale: 1.05, backgroundColor: "#1d4ed8" }}
                    whileTap={{ scale: 0.95 }}
                    onClick={() => {
                      setSelectedTicket(null);
                      setFormData({ 
                          subject: '', 
                          contact_name: '', 
                          property_name: '', 
                          ticket_owner: user.name, 
                          priority: 'Low', 
                          status: 'Open',
                          date: new Date().toISOString().split('T')[0] 
                        });
                      setIsFormOpen(true);
                    }}
                  >
                    <PlusCircle size={20} />
                    <span>New Ticket</span>
                  </motion.button>
                </div>
              </header>

              <motion.div 
                className="stats-grid"
                initial="hidden"
                animate="show"
                variants={{ hidden: { opacity: 0 }, show: { opacity: 1, transition: { staggerChildren: 0.1 } }}}
              >
                {[
                  { label: 'All Tickets', count: tickets.length, class: 'card-0' },
                  { label: 'Ongoing', count: tickets.filter(t => t.status !== 'Resolved').length, class: 'card-1' },
                  { label: 'Critical', count: tickets.filter(t => t.priority === 'Critical').length, class: 'card-2' },
                  { label: 'In Progress', count: tickets.filter(t => t.status === 'In Progress').length, class: 'card-1' },
                  { label: 'Resolved', count: tickets.filter(t => t.status === 'Resolved').length, class: 'card-0' },
                ].map((item, i) => (
                  <motion.div key={i} variants={{ hidden: { y: 20, opacity: 0 }, show: { y: 0, opacity: 1 } }} whileHover={{ y: -5 }} className={`card ${item.class}`}>
                    <span>{item.label}</span>
                    <h3>{item.count}</h3>
                  </motion.div>
                ))}
              </motion.div>

              <section className="table-container">
                <table className="modern-table">
                  <thead>
                    <tr>
                      <th>ID</th>
                      <th>Subject</th>
                      <th>User</th>
                      <th>Priority</th>
                      <th>Status</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {filteredTickets.map(t => (
                      <tr key={t.id}>
                        <td><span className="id-tag">#{t.id}</span></td>
                        <td className="subject-cell">{t.subject}</td>
                        <td>{t.ticket_owner || "Unknown User"}</td>
                        <td>
                          <div className={`modern-priority priority-${t.priority.toLowerCase()}`}>
                            <span className="dot"></span> {t.priority}
                          </div>
                        </td>
                        <td>
                          <div className={`modern-badge status-${t.status.toLowerCase().replace(/\s+/g, '-')}`}>
                            {t.status}
                          </div>
                        </td>
                        <td>
                          <div className="action-buttons">
                            <button 
                              className="action-btn view" 
                              style={{ backgroundColor: '#eef2ff', color: '#6366f1', border: 'none', padding: '6px', borderRadius: '6px', cursor: 'pointer'}}
                              onClick={() => navigate(`/ticket/${t.id}`)}
                            >
                              <Eye size={16} />
                            </button>

                            <button className="action-btn edit" onClick={() => { 
                                if (t.status === 'Closed') {
                                    showToast("This ticket is closed and cannot be modified.", "warning");
                                    return;
                                }
                                setSelectedTicket(t); 
                                setFormData({ ...t }); 
                                setIsFormOpen(true); 
                            }}>
                              <Edit3 size={16} />
                            </button>
                            {user.role === 'Admin' && (
                              <button 
                                className="action-btn delete" 
                                style={{ backgroundColor: '#fee2e2', color: '#ef4444', border: 'none', padding: '6px', borderRadius: '6px', cursor: 'pointer' }}
                                onClick={() => handleDelete(t.id)}
                              >
                                <Trash2 size={16} />
                              </button>
                            )}
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
                {filteredTickets.length === 0 && <div className="no-results">No tickets found</div>}
                {/* PAGINATION CONTROLS */}
                {/* MODERN PAGINATION FOOTER */}
                <div className="pagination-container" style={{
                      display: 'flex',
                      flexDirection: 'column', // Stack info above buttons for a clean look
                      alignItems: 'center',
                      gap: '12px',
                      padding: '24px',
                      background: '#ffffff',
                      borderTop: '1px solid #f1f5f9',
                      marginTop: 'auto'
                  }}>
                      {/* Dynamic Range Label: e.g., "Showing 11 - 20 of 45 tickets" */}
                      {/* <div style={{ color: '#64748b', fontSize: '13px', fontWeight: '500' }}>
                          Showing <span style={{ color: '#6366f1' }}>{(currentPage - 1) * 10 + 1}</span> to{' '}
                          <span style={{ color: '#6366f1' }}>{Math.min(currentPage * 10, tickets.length * totalPages)}</span> of{' '}
                          {tickets.length * totalPages} tickets
                      </div> */}

                      <div style={{ display: 'flex', gap: '6px', alignItems: 'center' }}>
                          <button
                              disabled={currentPage === 1}
                              onClick={() => setCurrentPage(1)}
                              className="pagination-btn jump-btn"
                          >
                              <ChevronsLeft size={18} />
                          </button>

                          <button
                              disabled={currentPage === 1}
                              onClick={() => setCurrentPage(prev => prev - 1)}
                              className="pagination-btn"
                          >
                              <ChevronLeft size={18} />
                          </button>

                          <div style={{ display: 'flex', gap: '4px', margin: '0 8px' }}>
                              {[...Array(totalPages)].map((_, index) => {
                                  const pageNum = index + 1;
                                  if (pageNum === 1 || pageNum === totalPages || (pageNum >= currentPage - 1 && pageNum <= currentPage + 1)) {
                                      return (
                                          <button
                                              key={pageNum}
                                              onClick={() => setCurrentPage(pageNum)}
                                              className={`page-number ${currentPage === pageNum ? 'active' : ''}`}
                                          >
                                              {pageNum}
                                          </button>
                                      );
                                  } else if (pageNum === currentPage - 2 || pageNum === currentPage + 2) {
                                      return <span key={pageNum} className="pagination-ellipsis">...</span>;
                                  }
                                  return null;
                              })}
                          </div>

                          <button
                              disabled={currentPage === totalPages}
                              onClick={() => setCurrentPage(prev => prev + 1)}
                              className="pagination-btn"
                          >
                              <ChevronRight size={18} />
                          </button>

                          <button
                              disabled={currentPage === totalPages}
                              onClick={() => setCurrentPage(totalPages)}
                              className="pagination-btn jump-btn"
                          >
                              <ChevronsRight size={18} />
                          </button>
                      </div>
                  </div>
              </section>
            </motion.div>
          )}

          {/* 2. CHAT TAB */}
          {activeTab === 'chat' && (
            <motion.div
              key="chat-tab"
              initial={{ opacity: 0, scale: 0.98 }}
              animate={{ opacity: 1, scale: 1 }}
              exit={{ opacity: 0, scale: 0.98 }}
              style={{ 
                width: '100%', 
                height: '100%', 
                display: 'flex', 
                alignItems: 'center', 
                justifyContent: 'center',
                overflow: 'hidden', // PREVENTS THE PAGE FROM SCROLLING
                boxSizing: 'border-box'
              }}
            >
              <div className="chat-container" style={{ 
                width: '100%',              // Changed to 95% to leave a small gap
                // maxWidth: '1200px', 
                height: '90vh',            // Fixed height
                display: 'flex', 
                flexDirection: 'column', 
                background: 'white', 
                borderRadius: '12px', 
                overflow: 'hidden',        // Keep this so chat scroll stays INSIDE the box
                boxShadow: '0 10px 25px rgba(0,0,0,0.1)', 
              }}>
                <ChatView user={user} />
              </div>
            </motion.div>
          )}

          {/* 3. TEAM TAB */}
          {activeTab === 'team' && (
            <motion.div
              key="team-tab"
              initial={{ opacity: 0, scale: 0.98 }}
              animate={{ opacity: 1, scale: 1 }}
              exit={{ opacity: 0 }}
              style={{ width: '100%', display: 'flex', flexDirection: 'column' }}
            >
              {user.role === 'Admin' ? (
                <TeamView user={user} showToast={showToast} /> 
              ) : (
                <div className="placeholder-view">
                  <ShieldCheck size={48} color="#ef4444" />
                  <h2>Access Denied</h2>
                  <button className="cancel-btn" onClick={() => setActiveTab('tickets')}>Go Back</button>
                </div>
              )}
            </motion.div>
          )}

          {/* 4. SCRIPTS TAB */}
          {activeTab === 'scripts' && (
            <motion.div 
              key="scripts-tab" 
              initial={{ opacity: 0 }} 
              animate={{ opacity: 1 }}
              style={{ width: '100%', display: 'flex', flexDirection: 'column' }}
            >
              <ScriptsView showToast={showToast} />
            </motion.div>
          )}

          {/* 5. SETTINGS TAB */}
          {activeTab === 'settings' && (
            <motion.div 
              key="settings-tab" 
              initial={{ opacity: 0, x: 20 }} 
              animate={{ opacity: 1, x: 0 }} 
              style={{ width: '100%', display: 'flex', flexDirection: 'column' }}
              className="placeholder-view"
            >
              <SettingsIcon size={48} /> 
              <h2>Settings</h2>
              <p>Configure {user.role} preferences</p>
            </motion.div>
          )}

        </AnimatePresence>
      </main>

      <TicketModal 
        isFormOpen={isFormOpen}
        setIsFormOpen={setIsFormOpen}
        selectedTicket={selectedTicket}
        formData={formData}
        setFormData={setFormData}
        handleSubmit={handleSubmit}
        user={user}
      />
    </div>
  );
};

export default Dashboard;